import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import BuyButton from "./BuyButton";
import { Svg } from './Svg'
import { translate } from "../Services/translation";
import { setPriceRequestResponse } from '../Actions/Cart.action';

const ButtonLabel = ({label, hidePrice}) => <div><span>{label}</span> {!hidePrice && <Svg icon="cart" />}</div>;

/**
 *
 * @param variant
 * @param {function} handleQuantityInput
 * @param {object} order
 * @param {boolean} isCart
 * @returns {JSX.Element}
 * @constructor
 */
const AddToCart = ({ variant, isQuotationProduct, handleQuantityInput, order, isCart = false }) => {
    const { priceRequestResponse } = useSelector((state) => state.cart);
    const dispatch = useDispatch();
    const baseWidth = 40;
    let width = baseWidth;
    let onChangeTimeoutDuration = isCart ? 100 : 400;
    const minValue = 1;
    const maxValue = 999;
    const timeoutRef = useRef(0);

    // No need for a Redux state, a local state should be enough.
    const [quantity, setQuantity] = useState(order?.quantity || 1);

    const clearPriceRequestResponse = () => {
        dispatch(setPriceRequestResponse(null, null));
    }

    useEffect(() => {
        if (timeoutRef.current && priceRequestResponse === null) {
            clearTimeout(timeoutRef.current);
            return;
        }
        timeoutRef.current = setTimeout(clearPriceRequestResponse, 10000);

        return () => clearTimeout(timeoutRef.current);
    }, [priceRequestResponse]);

    const decrementQty = () => {
        let newValue = quantity - 1;
        newValue = newValue <= minValue ? minValue : newValue;
        setQuantity(newValue);
    }

    const incrementQty = () => {
        let newValue = quantity + 1;
        newValue = newValue >= maxValue ? maxValue : newValue;
        setQuantity(newValue);
    }

    /**
     * Validate and adjust minimum and maximum quantity values.
     * @param {number} value
     * @returns {number}
     */
    const validateMinMax = (value) => {
        value = value <= minValue ? minValue : value;
        return value >= maxValue ? maxValue : value;
    }

    /**
     *
     * @param {InputEvent} e
     */
    const onInputChange = e => {
        let value = typeof e.target.value !== 'number' ? parseInt(e.target.value) : e.target.value;
        setQuantity(validateMinMax(value))
    };

    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            let newValue = validateMinMax(quantity);

            if (isCart && typeof order?.articleNumber !== 'undefined') {
                handleQuantityInput(order.articleNumber.toString(), newValue, order.rowSystemId, false);
            } else {
                setQuantity(newValue);

                if (typeof handleQuantityInput === 'function') {
                    handleQuantityInput(newValue);
                }
            }
        }, onChangeTimeoutDuration);
    }, [quantity, setQuantity]);

    // Calculate dynamic input width
    width = baseWidth + (quantity.toString().length * 3);

    let buyButtonEnabled = typeof variant?.url !== 'undefined' && variant?.url !== '' && variant?.price?.hasPrice;
    let buttonClass = 'button button--sm js-add-to-cart' + (!buyButtonEnabled ? ' disabled' : '');

    if (isCart && (typeof handleQuantityInput !== 'function' || !order)) {
        throw new Error("Invalid usage");
    }

    let hasRepalcementProductText = variant?.replacementProductText && variant?.replacementProductUrl;
    let showQuantityFields = !isQuotationProduct && (isCart || (typeof variant !== 'undefined' && variant.showQuantityField && !variant.isAnonymousUser && !hasRepalcementProductText));
    return (
        <div className={'add-to-cart' + ((!isCart && isQuotationProduct) ? ' add-to-cart--price-request' : '') + ((!isCart && variant.isAnonymousUser) ? ' add-to-cart--login' : '')}>
            {showQuantityFields && (
                <div className="add-to-cart__qty-container">
                    <button type="button" className="add-to-cart__qty-button" onClick={decrementQty}><span>-</span></button>
                    <input type="text" value={quantity} onInput={onInputChange} id={variant?.quantityFieldId || ''} style={{ width: width }} />
                    <button type="button" className="add-to-cart__qty-button" onClick={incrementQty}><span>+</span></button>
                </div>
            )}

            {!isCart && (
                <div className="add-to-cart__button-container">
                {!variant.isAnonymousUser ? (
                    (hasRepalcementProductText && !variant.isInStock) ? (
                        <a className="replacement-product-text" href={variant.replacementProductUrl}>{variant.replacementProductText}</a>
                    ): (
                    <BuyButton
                        label={<ButtonLabel label={isQuotationProduct ? translate('nmas.product.pricerequest.text') : translate('nmas.product.buy')} hidePrice={isQuotationProduct} />} {...{
                        articleNumber: variant.id,
                        quantityFieldId: variant.quantityFieldId,
                        isQuotationProduct: isQuotationProduct,
                        href: '#',
                        cssClass: buttonClass,
                        }} />
                    ) 
                ) : (
                    <BuyButton label={translate('nmas.product.price.login')} {...{
                        href: variant.loginUrl,
                        cssClass: 'button button--sm',
                    }} />
                )}
                </div>
            )}

            {priceRequestResponse && (priceRequestResponse.message && priceRequestResponse.articleNumber == variant.id) && (
                <div className='price-request-button__response'>
                    <span>{priceRequestResponse.message}</span>
                </div>
            )}
        </div>
    )
}

export default AddToCart;